module.exports = __webpack_public_path__ + "docs/token-1f9cac.md";